export default class CharacterCounter {

	private containerElement: HTMLElement;
	private fieldElement: HTMLInputElement;
	private counterElement: HTMLElement;
	private maxCharacters: number;

	constructor(containerElement: HTMLElement) {

		this.containerElement = containerElement;
		this.fieldElement = containerElement.querySelector('.js-character-counter-field');
		this.counterElement = containerElement.querySelector('.js-character-counter-text');
		this.maxCharacters = parseInt(containerElement.getAttribute('data-max-characters'));

		this.assignEvents();
		this.renderCounter(this.fieldElement.value.length);

	}

	private assignEvents() {
		this.fieldElement.addEventListener('input', () => {
			this.renderCounter(this.fieldElement.value.length);
		});
	}

	private renderCounter(count: number) {
		if (count === 0) {
			this.counterElement.textContent = "";
			return;
		}
		this.counterElement.textContent = `${count}/${this.maxCharacters}`;
		if (count > this.maxCharacters) {
			this.counterElement.classList.add('formLabelCounter__text--over');
		} else {
			this.counterElement.classList.remove('formLabelCounter__text--over');
		}
	}

}
